import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 2rem 1.5rem;
  font-family: ${theme.fonts.main};
  background: #fafbfc;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
`;

export const Title = styled.h1`
  text-align: center;
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  color: #1a237e;
`;

export const SubTitle = styled.p`
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 2.5rem;
  font-size: 1.15rem;
  color: #333;
  font-weight: 500;
`;

export const Highlight = styled.div`
  color: #ff9900;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  margin: 0.5rem 0;
`;

export const Section = styled.section`
  margin: 2.5rem 0;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
`;

export const Quote = styled.blockquote`
  margin: 1.5rem auto;
  padding: 1rem 1.5rem;
  background: #f9f6f2;
  border-left: 4px solid #f5a623;
  font-style: italic;
  color: #333;
  max-width: 700px;
`;

export const CampusList = styled.div`
  margin: 2.5rem 0 2.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  align-items: center;
`;

export const CampusCard = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(26,35,126,0.07);
  padding: 1.1rem 2rem;
  min-width: 260px;
  max-width: 420px;
  width: 100%;
  text-align: left;
  font-size: 1.08rem;
  font-weight: 500;
  color: #263238;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 16px rgba(26,35,126,0.13);
  }
`;

export const CampusListTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1.2rem;
  color: #3949ab;
  text-align: center;
`;

export const Footer = styled.footer`
  margin-top: 3rem;
  text-align: center;
  font-size: 1rem;
  color: #555;
`;

export const MailLink = styled.a`
  color: #3949ab;
  text-decoration: none;
  font-weight: 700;
  border: 1.5px solid #3949ab;
  border-radius: 6px;
  padding: 0.18em 0.7em;
  margin-left: 0.3em;
  background: #f5f7fa;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #3949ab;
    color: #fff;
    text-decoration: none;
  }
`;